import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

export const ContentUnitLayout = styled(Vertical).attrs({
  gap: 2,
  center: true,
})`
  height: 100%;
  justify-content: space-between;
  padding: calc(6 * var(--unit)) 0 calc(9 * var(--unit));
`;
